export default {
  'You have worked today': '您今天已工作了',
  'Continue to work': '继续工作',
  'have a bit of rest': '休息片刻',
  'Member registration': '会员注册量',
  'Total number of members': '会员总数',
  'Number of installed plug-ins': '已装插件数',
  'Membership growth': '会员增长情况',
  'Annex growth': '附件增长情况',
  'New member': '刚刚加入的会员',
  'Joined us': '加入了我们',
  'Member source': '会员来源',
  'Member last name': '会员姓氏',
  Loading: '加载中...',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  Sunday: '周日',
  Visits: '访问量',
  'Registration volume': '注册量',
  month: '月',
  picture: '图片',
  file: '文档',
  table: '表格',
  'Compressed package': '压缩包',
  Baidu: '百度',
  'Direct access': '直接访问',
  'take a plane': '坐飞机',
  'Take the high-speed railway': '坐高铁',
  'full name': '姓名',
  hour: '小时',
  minute: '分',
  second: '秒',
  day: '天',
  'Number of attachments Uploaded': '附件上传量'
}
